module.exports = __webpack_public_path__ + "static/media/logo_bidv.017430ca.svg";